import type { Color } from '@mui/material';
import type { PaletteColor, PaletteColorOptions } from '@mui/material/styles';

type ExtendedPaletteColor = PaletteColor & { xlight?: string };

export const grey: Partial<Color> = {
  50: '#FFFFFF',
  200: '#F5F3F6',
  300: '#D9D6DB',
  400: '#BFBCC2',
  500: '#8C8990',
  600: '#666468',
  700: '#2B2A2C',
  900: '#000000',
};

export const contrastText = grey[700];

export const pink: ExtendedPaletteColor = {
  contrastText,
  main: '#FE8275',
  dark: '#5E0B15',
  light: '#FFC8C2',
  xlight: '#FFE3E0',
};

export const blue: ExtendedPaletteColor = {
  contrastText,
  main: '#7BA5EF',
  dark: '#456990',
  light: '#C9DAF8',
  xlight: '#EEF4FF',
};

export const green: ExtendedPaletteColor = {
  contrastText,
  main: '#7EB176',
  dark: '#234D38',
  light: '#D8E9D9',
  xlight: '#EEF5F0',
};

export const yellow: ExtendedPaletteColor = {
  contrastText,
  main: '#F6CE79',
  dark: '#FABC3C',
  light: '#FBEAC6',
  xlight: '#FDF5E2',
};

export const purple: ExtendedPaletteColor = {
  contrastText,
  main: '#A491D3',
  dark: '#564256',
  light: '#DBD3EE',
  xlight: '#EDE9F7',
};

export const twitter: PaletteColorOptions = {
  main: '#1da1f2',
  dark: '#1F7FB1',
  contrastText: '#FFF',
};

export const facebook: PaletteColorOptions = {
  main: '#4267B2',
  dark: '#1F7FB1',
  contrastText: '#FFF',
};

export const google: PaletteColorOptions = {
  light: '#FFF',
  main: '#F6F6F6',
  dark: '#7B8D9A',
  contrastText: '#162E3D',
};

export const zoom: PaletteColorOptions = {
  main: '#008AFF',
  contrastText: '#FFF',
};

export const palette = {
  grey,
  divider: grey[300],
  error: pink,
  primary: blue,
  textPrimary: {
    main: contrastText,
  },
  textSecondary: {
    main: grey[600],
  },
  secondary: purple, // Needed for IconButton variants to work
  secondary_dark: {
    xlight: purple.light,
    light: purple.main,
    main: purple.dark,
    dark: purple.dark,
  },
  info: {
    xlight: grey[200],
    light: grey[300],
    main: grey[500],
    dark: grey[600],
    contrastText: grey[900],
  },
  success: green,
  warning: yellow,
  common: {
    white: grey[50],
    black: grey[900],
  },
  text: {
    primary: contrastText,
    secondary: grey[600],
    disabled: grey[500],
  },
  background: {
    paper: grey[50],
    default: grey[50],
  },
  socials: {
    facebook,
    google,
    twitter,
    zoom,
  },
};
